import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchMyCars,
  fetchContactDetails,
  fetchLoanDetails,
  fetchBankDetails,
  fetchTransactionHistory,
  setCurrentVehicle,
} from '../ducks/actions';
import type { RootState } from '../store/configureStore';

const MyCarsRefreshHook = (vehicleId: any) => {
  // Refresh Logic and Store Hydration
  const dispatch = useDispatch();

  // Set Current Vehicle ID in Store
  dispatch(setCurrentVehicle({ vehicleId: Number(vehicleId) }));

  // Get API response status
  const { isComplete: isMyCarsDetailsComplete } = useSelector(
    (state: RootState) => state?.myCars?.myCarsAPIStatus
  );

  const isContactDetailsComplete = useSelector(
    (state: RootState) => state?.myCars?.isContactDetailsComplete
  );

  const isLoanDetailsComplete = useSelector((state: RootState) => {
    const currentVehicle = state?.myCars?.cars?.filter(
      (carItem: any) => carItem.vehicle.vehicleId === Number(vehicleId)
    );
    return currentVehicle[0]?.isLoanDetailsComplete;
  });

  const isBankDetailsComplete = useSelector((state: RootState) => {
    const currentVehicle = state?.myCars?.cars?.filter(
      (carItem: any) => carItem.vehicle.vehicleId === Number(vehicleId)
    );
    return currentVehicle[0]?.isBankDetailsComplete;
  });

  const isTransactionHistoryComplete = useSelector((state: RootState) => {
    const currentVehicle = state?.myCars?.cars?.filter(
      (carItem: any) => carItem.vehicle.vehicleId === Number(vehicleId)
    );
    return currentVehicle[0]?.isTransactionHistoryComplete;
  });

  useEffect(() => {
    if (!isMyCarsDetailsComplete) {
      dispatch(fetchMyCars(process.env.NODE_ENV));
    }
    if (isMyCarsDetailsComplete && !isContactDetailsComplete) {
      dispatch(fetchContactDetails(process.env.NODE_ENV));
    }
    if (isMyCarsDetailsComplete && !isLoanDetailsComplete) {
      dispatch(fetchLoanDetails(process.env.NODE_ENV, vehicleId));
    }
    if (isMyCarsDetailsComplete && !isBankDetailsComplete) {
      dispatch(fetchBankDetails(process.env.NODE_ENV, vehicleId));
    }
    if (isMyCarsDetailsComplete && !isTransactionHistoryComplete) {
      dispatch(fetchTransactionHistory(process.env.NODE_ENV, vehicleId));
    }
  }, [
    isLoanDetailsComplete,
    isContactDetailsComplete,
    isBankDetailsComplete,
    isTransactionHistoryComplete,
    isMyCarsDetailsComplete,
  ]);

  if (
    isLoanDetailsComplete &&
    isBankDetailsComplete &&
    isTransactionHistoryComplete &&
    isMyCarsDetailsComplete
  ) {
    return false; // Still Loading
  }

  return true; // Complete

  // Refresh Logic and Store Hydration - End
};

export default MyCarsRefreshHook;
